export default "__VITE_ASSET__Or7HXn5Z__"